export interface SourceItem {
  _id: string;
  name: string;
  project_id: string | null;
  enabled?: boolean;
  status?: string;
}

export interface DatasetItem {
  _id: string;
  name: string;
  file_name: string;
  description?: string | null;
  source_id: string;
  contract_id?: string;
  enabled?: boolean;
  status?: string;
}

export interface SeriesItem {
  _id: string;
  name: string;
  unit: string;
  temporal_column?: string;
  last_job_execution: JobExecution | null;
}

export interface JobExecution {
  _id: string;
  version: number;
  status: 'queued' | 'processing' | 'completed' | 'failure' | 'outdated' | 'initializing' | 'new' | 'notDone' | 'skip';
  updatedAt?: string;
  updated_at?: string;
}

/** @deprecated GET /series retorna lista plana; use SeriesItem[] diretamente. */
export interface DatasetGroup {
  dataset_id: string;
  name: string;
  file_name: string;
  description?: string | null;
  source_id: string;
  series: SeriesItem[];
  status?: string | null;
}

export interface SeriesDetail {
  _id: string;
  name: string;
  description?: string;
  dataset_id: string;
  dataset_name: string;
  temporal_column?: string;
  unit: string;
  enabled?: boolean;
  createdAt: string;
  updatedAt: string;
  __v?: number;
}

export interface PaginatedResponse<T> {
  count: number;
  rows: T[];
}

/** ID do source BBCE (antigo dataset_id, preservado na migração). */
export const BBCE_SOURCE_ID = '69cc0506c0678f5df62e5f2d';
